// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconArrowDownBold.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconArrowDownBold = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 12" fill="currentColor" { ...props }>
    <path d="M16 3.24997L13.3333 0.5L7.99995 6.00004L2.66665 0.500101L0 3.25008L7.99996 11.5L16 3.24997Z" />
  </BaseIcon>
);

export default IconArrowDownBold;
